import { button } from '../button'

const block = document.querySelector('.vp-block-agencies')
let agencies, select, agence, title, locs, contacts, actions

if (block) {
  agencies = window.agencies
  select = block.querySelector('select')
  agence = block.querySelector('.agence')
  title = agence.querySelector('.title')
  locs = block.querySelector('.locs')
  contacts = agence.querySelector('.contacts')
  actions = agence.querySelector('.actions')

  for (const row of agencies) {
    locs.innerHTML += pinMap(row)
  }

  locs.addEventListener('mouseover', (e) => {
    const element = e.target.closest('svg')
    if (element && title.innerHTML !== element.dataset.ville) {
      agence.classList.add('tease')
      title.innerHTML = element.dataset.ville
    }
  })

  locs.addEventListener('mouseout', (e) => {
    const element = e.target.closest('svg')
    if (element) {
      agence.classList.remove('tease')
      title.innerHTML = agence.dataset.title
    }
  })

  locs.addEventListener('click', (e) => {
    const element = e.target.closest('svg')
    if (element) {
      const id = element.dataset.id || ''
      select.value = id
      select.dispatchEvent(new Event('input'))
    }
  })

  select.addEventListener('input', (e) => {
    setAgence(e.target.value || '')
  })

  select.value = ''
}

function setAgence(id) {
  if (id === '') {
    locs.querySelector('.on')?.classList.remove('on')
    title.innerHTML = agence.dataset.default
    contacts.innerHTML = ``
    actions.innerHTML = ``
    agence.classList.add('tease')
    setTimeout(function () {
      agence.classList.remove('tease')
    }, 0)
    return
  }

  let data
  for (const row of agencies) {
    if (row.id == id) data = row
  }

  if (!data) {
    throw new Exception('Agence non trouvée')
  }

  // sync map/select
  locs.querySelector('.on')?.classList.remove('on')
  locs.querySelector(`[data-id="${data.id}"]`)?.classList.add('on')
  select.value = id

  // set agence data
  agence.dataset.title = data.ville
  title.innerHTML = data.ville
  if (data.contacts && data.contacts.length) {
    contacts.innerHTML = data.contacts
      .map((d) => {
        const image = d.photo.length
          ? `<img class="image" src="${d.photo[0]}" width="${d.photo[1]}" height="${d.photo[2]}" />`
          : ``
        const name = d.title ? `<div class="name">${d.title}</div>` : ``
        const func = d.function
          ? `<div class="function">${d.function}</div>`
          : ``
        return `<li class="contact">${image}<div>${name}${func}</div></li>`
      })
      .join('')
  } else {
    contacts.innerHTML = `&nbsp;`
  }
  if (data.url) {
    actions.innerHTML = ``
    const a = document.createElement('a')
    a.classList.add('vp-button', 'is-style-outline', 'is-style-inverse')
    a.href = data.url
    a.innerHTML = agence.dataset.actions
    a.innerHTML = button(a)
    actions.appendChild(a)
  } else {
    actions.innerHTML = `&nbsp;`
  }
  agence.classList.add('tease')
  setTimeout(function () {
    agence.classList.remove('tease')
  }, 0)
}

function pinMap(data) {
  return `<svg class="vp-icon vp-pin-map" aria-hidden="true" style="${data.loc}" data-id="${data.id}" data-ville="${data.ville}"><use xlink:href="#icon-pin-map"></use></svg`
}
